import { QuizQuestion } from '@/types';

export const quizQuestions: QuizQuestion[] = [
  // Q1: Age
  {
    id: 'q1_age',
    type: 'single-select',
    question: 'What is your age?',
    required: true,
    options: [
      { label: '18-24', value: '18-24' },
      { label: '25-29', value: '25-29' },
      { label: '30-34', value: '30-34' },
      { label: '35-39', value: '35-39' },
      { label: '40-45', value: '40-45' },
      { label: '45+', value: '45+' },
    ],
  },

  // Interstitial: Hook
  {
    id: 'q2_hook',
    type: 'interstitial',
    title: 'Why You\'re Not Getting Results',
    content: 'The top 20% of men get 78% of all matches. It\'s not because they\'re all better looking—they just know what to say. DateHack gives you that same advantage.',
  },

  // Q3: The Frustration Question
  {
    id: 'q3_frustration',
    type: 'single-select',
    question: 'Be honest - what\'s the most frustrating part of dating apps for you?',
    required: true,
    options: [
      { label: 'I get matches but they never respond to my first message', value: 'no_response' },
      { label: 'Conversations start well then she just disappears', value: 'ghosted_mid_convo' },
      { label: 'I can\'t seem to get matches in the first place', value: 'no_matches' },
      { label: 'I get her interested but don\'t know how to ask her out', value: 'cant_close' },
      { label: 'I\'ve been at this for months and barely have anything to show for it', value: 'months_no_results' },
      { label: 'I know what I want but can\'t seem to get there', value: 'stuck' },
    ],
  },

  // Q4: The Pattern Question
  {
    id: 'q4_pattern',
    type: 'single-select',
    question: 'Think about your last few conversations that went nowhere. What usually happens?',
    required: true,
    options: [
      { label: 'She responds once or twice then ghosts', value: 'early_ghost' },
      { label: 'We chat for days but it never goes anywhere', value: 'endless_chat' },
      { label: 'I run out of things to say after a few messages', value: 'run_out' },
      { label: 'She seems interested but I never pull the trigger on asking her out', value: 'dont_ask' },
      { label: 'I ask her out and she says "maybe" or stops responding', value: 'rejected_ask' },
      { label: 'We exchange numbers but then it dies', value: 'dies_after_number' },
    ],
  },

  // Q5: Dating Apps
  {
    id: 'q5_apps',
    type: 'multi-select',
    question: 'Which dating apps are you using?',
    instruction: 'Select all that apply.',
    required: true,
    options: [
      { label: 'Tinder', value: 'tinder' },
      { label: 'Bumble', value: 'bumble' },
      { label: 'Hinge', value: 'hinge' },
      { label: 'Match', value: 'match' },
      { label: 'OkCupid', value: 'okcupid' },
      { label: 'Coffee Meets Bagel', value: 'cmb' },
      { label: 'Other', value: 'other' },
    ],
  },

  // Q6: Timeline Question
  {
    id: 'q6_timeline',
    type: 'single-select',
    question: 'How long have you been trying to make dating apps work?',
    required: true,
    options: [
      { label: 'Just getting started', value: 'just_started' },
      { label: 'A few weeks', value: 'few_weeks' },
      { label: 'A few months', value: 'few_months' },
      { label: '6+ months and still struggling', value: 'six_months' },
      { label: 'Over a year - I\'m running out of patience', value: 'over_year' },
    ],
  },

  // Interstitial: You're Not Alone
  {
    id: 'q7_validation',
    type: 'interstitial',
    title: 'You\'re Not Alone',
    content: '78% of guys on dating apps send "hey" and wonder why they get ignored. The top 20% know exactly what to say—and when. That\'s what DateHack gives you.',
  },

  // Q8: The Opener Question
  {
    id: 'q8_opener',
    type: 'single-select',
    question: 'What\'s your typical opening message?',
    required: true,
    options: [
      { label: '"Hey" or "Hi, how are you?"', value: 'hey' },
      { label: 'Something about her photos or bio', value: 'personalized' },
      { label: 'A joke or pickup line', value: 'joke' },
      { label: 'I overthink it and sometimes don\'t message at all', value: 'overthink' },
      { label: 'I try to be different but it still doesn\'t work', value: 'try_different' },
    ],
  },

  // Q9: The Self-Awareness Question
  {
    id: 'q9_holding_back',
    type: 'single-select',
    question: 'What do YOU think is the main thing holding you back?',
    required: true,
    options: [
      { label: 'I don\'t know what to say to keep her interested', value: 'dont_know_what_to_say' },
      { label: 'I\'m too nice / not confident enough in my messages', value: 'too_nice' },
      { label: 'My profile probably doesn\'t stand out', value: 'weak_profile' },
      { label: 'I wait too long to make a move', value: 'wait_too_long' },
      { label: 'I come on too strong or too available', value: 'too_strong' },
      { label: 'Honestly, I don\'t know - that\'s why I\'m here', value: 'dont_know' },
    ],
  },

  // Q10: The Comparison Question
  {
    id: 'q10_profile_confidence',
    type: 'single-select',
    question: 'How do you feel about your profile compared to other guys?',
    required: true,
    options: [
      { label: 'I think it\'s decent but obviously something\'s not working', value: 'decent_not_working' },
      { label: 'Honestly, it\'s probably generic', value: 'generic' },
      { label: 'I\'ve put effort in but don\'t get the results I expected', value: 'effort_no_results' },
      { label: 'I have no idea what makes a good profile', value: 'no_idea' },
      { label: 'I think I\'m better than my results show', value: 'better_than_results' },
    ],
  },

  // Interstitial: We See The Pattern
  {
    id: 'q11_pattern_insight',
    type: 'interstitial',
    title: 'We See The Pattern',
    content: 'Based on what you\'re telling us, you\'re losing her somewhere in the first 5-6 messages. That\'s fixable. DateHack\'s 7-phase framework shows you exactly when to escalate and how.',
  },

  // Q12: What You Want
  {
    id: 'q12_want',
    type: 'multi-select',
    question: 'What do you actually want from dating apps?',
    instruction: 'Be honest - select all that apply.',
    required: true,
    options: [
      { label: 'More dates - my calendar should be full', value: 'more_dates' },
      { label: 'Stop getting ghosted - actually meet up', value: 'stop_ghosting' },
      { label: 'Get her number faster - stop endless texting', value: 'get_number' },
      { label: 'Find a girlfriend', value: 'girlfriend' },
      { label: 'Casual hookups - no judgment', value: 'hookups' },
      { label: 'Just more options in general', value: 'more_options' },
    ],
  },

  // Q13: Why It Matters
  {
    id: 'q13_why',
    type: 'single-select',
    question: 'Why does this actually matter to you right now?',
    required: true,
    options: [
      { label: 'I\'m tired of being alone on weekends', value: 'lonely' },
      { label: 'All my friends are in relationships and I\'m still swiping', value: 'friends_coupled' },
      { label: 'I know I have a lot to offer but can\'t seem to show it', value: 'cant_show_value' },
      { label: 'I want consistent options, not dry spells', value: 'consistent_options' },
      { label: 'I\'m done wasting time on apps that don\'t work', value: 'done_wasting_time' },
      { label: 'I just want to meet someone I actually like', value: 'meet_someone' },
    ],
  },

  // Interstitial: Here's The Truth
  {
    id: 'q14_truth',
    type: 'interstitial',
    title: 'Here\'s The Truth',
    content: 'It\'s two things: your photos and your messages. Your photos need to project confidence and masculinity. Your messages need to stand out from every other guy in her inbox. DateHack helps with both.',
  },

  // Q15: Email
  {
    id: 'q15_email',
    type: 'text-input',
    question: 'One last step!',
    instruction: 'Enter your email to see your personalized dating profile analysis',
    placeholder: 'your@email.com',
    required: true,
  },
];

export const getTotalQuestions = () => quizQuestions.length;

export const getQuestionById = (id: string) => {
  return quizQuestions.find((q) => q.id === id);
};
